function debounce(method, delay) {
	clearTimeout(method._tId)
	method._tId = setTimeout(function () {
		method()
	}, delay)
}

export default function scrollHeader() {
	const headerWrapper = document.querySelector('.Header__Wrapper')

	window.addEventListener('scroll', () => {
		debounce(() => {
			if (window.scrollY > 70) {
				if (!headerWrapper.classList.contains('scrolled')) {
					headerWrapper.classList.add('scrolled')
				}
			} else {
				headerWrapper.classList.remove('scrolled')
			}
		}, 200)
	})
}
